import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AppConst, AppConsts } from '../shared/AppConsts';
import { ApiResponse } from '../interfaces/api';
import { GetExamConfigurationsResult } from '../interfaces/exam-configuration';
import {
  SessionInfoResult,
  UserProfileResult,
  LearnerProfileResult,
  GetLearnerProfilesResult,
  CurrentUserProfileResult,
  UserProfile,
  UpdateUserProfileBody,
  ProfilePictureResponse,
  UpdateProfilePictureBody,
} from '../interfaces/dashboard';
import { CreateLearnerProfileBody, ExamSession, ExamSessionResponse, LearnerExamEnrolment, LearnerExamEnrolmentResponse } from '../shared/models/learner-profile';
import { Observable, tap } from 'rxjs';
import { SessionService } from '../shared/services/session.service';

@Injectable({
  providedIn: 'root',
})
export class LearnerService {
  private http = inject(HttpClient);
  private readonly session = inject(SessionService);
  private get baseUrl() {
    return AppConst.apiBaseUrl;
  }

  getSessionInfo() {
    return this.http.get<ApiResponse<SessionInfoResult>>(
      `${this.baseUrl}/api/services/app/Session/GetCurrentLoginInformations`,
    );
  }

  getUserProfile(id?: number) {
    return this.http.get<ApiResponse<UserProfileResult>>(
      `${this.baseUrl}/api/services/app/Profile/GetCurrentUserProfileForEdit`,
    );
  }
  getUserProfileInfo() {
    return this.http.get<ApiResponse<UserProfile>>(
      `${this.baseUrl}/api/services/app/Profile/GetCurrentUserProfileForEdit`,
    ).pipe(tap(res => {
      if (res.success && res.result) {
        this.session.updateProfileImage(res.result.id, res.result.imageUrl ?? null);
      }
    }));
  }

  updateUserProfile(payload: UpdateUserProfileBody) {
    return this.http.put<ApiResponse<UserProfile>>(
      `${this.baseUrl}/api/services/app/Profile/UpdateCurrentUserProfile`,
      payload,
    ).pipe(tap(res => {
      if (res.success && payload.imageUrl !== undefined) {
        this.session.updateProfileImage(payload.id, payload.imageUrl);
      }
    }));
  }
  getUserProfileImg() {
    return this.http.get<ApiResponse<ProfilePictureResponse>>(
      `${this.baseUrl}/api/services/app/Profile/GetProfilePicture`,
    );
  }
  updateProfilePicture(payload: UpdateProfilePictureBody) {
    return this.http.put<ApiResponse<any>>(
      `${this.baseUrl}/api/services/app/Profile/UpdateCurrentUserProfile`,
      payload
    );
  }

  getLearnerProfile(id: number) {
    return this.http.get<ApiResponse<GetLearnerProfilesResult>>(
      `${this.baseUrl}/api/services/app/LearnerProfile/GetAll`,
      { params: { UserId: id } },
    );
  }

  createLearnerProfile(body: CreateLearnerProfileBody) {
    return this.http.post<ApiResponse<{ id: number }>>(
      `${this.baseUrl}/api/services/app/LearnerProfile/Create`,
      body,
    );
  }

  updateLearnerProfile(body: CreateLearnerProfileBody & { id: number }) {
    return this.http.put<ApiResponse<{ id: number }>>(
      `${this.baseUrl}/api/services/app/LearnerProfile/Update`,
      body,
    );
  }

  // getCurrentUserProfile() {
  //   return this.http.get<ApiResponse<CurrentUserProfileResult>>(
  //     `${this.baseUrl}/api/services/app/Profile/GetCurrentUserProfileForEdit`
  //   );
  // }
  createLearnersExamEnrolment(body: any) {
    return this.http.post<ApiResponse<any>>(
      `${this.baseUrl}/api/services/app/LearnersExamEnrolment/Create`,
      body,
    );
  }
  getAllLearnersExamEnrolment(
    learnerId: number,
    examType: number
  ): Observable<LearnerExamEnrolmentResponse> {
    const params = new HttpParams()
      .set('LearnerId', learnerId)
      .set('ExamType', examType);

    return this.http.get<LearnerExamEnrolmentResponse>(
      `${this.baseUrl}/api/services/app/LearnersExamEnrolment/GetAll`,
      { params }
    );
  }
  getExamSessionsByLearner(
    learnerId: number,
    examType:number
  ): Observable<ExamSessionResponse> {
    const params = new HttpParams()
      .set('learnerId', learnerId)
      .set('examType', examType);
    return this.http.get<ExamSessionResponse>(
      `${this.baseUrl}/api/services/app/ExamMockSession/GetExamSessionsByLearner`,
      { params }
    );
  }
  getExamSessionsById(id: number) {
    return this.http.get<ApiResponse<ExamSession>>(
      `${this.baseUrl}/api/services/app/ExamMockSession/Get?Id=${id}`
    );
  }
  getLearnerExamEnrolment(id: number) {
    return this.http.get<ApiResponse<LearnerExamEnrolment>>(
      `${this.baseUrl}/api/services/app/LearnersExamEnrolment/Get?Id=${id}`
    );
  }
  updateLearnerExamEnrolment(body: LearnerExamEnrolment) {
    return this.http.put<ApiResponse<LearnerExamEnrolment>>(
      `${this.baseUrl}/api/services/app/LearnersExamEnrolment/Update`,
      body,
    );
  }
  getReviewSession(examSessionId: number, learnerId: number) {
    return this.http.get(`${this.baseUrl}/api/services/app/MockExam/GetSessionState` +
      `?examSessionId=${examSessionId}` +
      `&learnerId=${learnerId}`)
  }

  getConfigExam(examType:number){
    return this.http.get<ApiResponse<GetExamConfigurationsResult>>(
      `${this.baseUrl}/api/services/app/ExamConfiguration/GetAll?ExamConfigType=${examType}`,
    );
  }

}
